import axios from 'axios'
import { getLocalStorage } from '../utils/get-local-storage'

export const apiConfig = (key: any, token: string) =>
  axios.create({
    baseURL: import.meta.env.VITE_REACT_APP_API_URL,
    headers: {
      'x-api-version': Number(import.meta.env.VITE_REACT_APP_API_VERSION),
      'x-application-key': key,
      'x-application-token': token,
      Authorization: `Bearer ${getLocalStorage('token')}`,
    },
  })
